<template>
    <div class="parent-container">
        <div class="content-container">
            <div class="topic-sign-title-top">子课题发布</div>
            <div class="topic-sign-name">（{{info.topicName}}）</div>
            <div class="topic-sign-form">
                <div class="topic-sign-title">
                    <div>
                        <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                    </div>
                    <div>立项与基础材料</div>
                </div>
                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        立项申报书
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="sbsFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :limit="1"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 1}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M  &nbsp;&nbsp;数量限制：1个（如需替换请移除原文件后重新上传并确认保存）
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        <span style="color: red">*</span>立项通知书
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="tzsFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :limit="1"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 2}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M &nbsp;&nbsp;数量限制：1个（如需替换请移除原文件后重新上传并确认保存）
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="topic-sign-title">
                    <div>
                        <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                    </div>
                    <div>开题报告</div>
                </div>
                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        <span style="color: red">*</span>开题报告
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="ktbgFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :limit="1"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 3}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M &nbsp;&nbsp;数量限制：1个（如需替换请移除原文件后重新上传并确认保存）
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="topic-sign-title">
                    <div>
                        <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                    </div>
                    <div>结题资料</div>
                </div>
                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        <span style="color: red">*</span>结题报告
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="jtbgFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :limit="1"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 4}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M &nbsp;&nbsp;数量限制：1个（如需替换请移除原文件后重新上传并确认保存）
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        工作报告
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="gzbgFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :limit="1"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 5}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M &nbsp;&nbsp;数量限制：1个（如需替换请移除原文件后重新上传并确认保存）
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="topic-sign-title">
                    <div>
                        <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                    </div>
                    <div>成果类材料</div>
                </div>
                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        论文与著作
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="lwzzFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 6}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        <span style="color: red">*</span>教学案例与课件
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="alkjFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 7}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        获奖证书
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="hjzsFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 8}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="topic-sign-title">
                    <div>
                        <svg style="margin-top: 9px;margin-right: 5px" t="1747039931209" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2906" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547797 0-20.369933 8.742105-37.893029 26.238594-52.547797 17.765619-14.655791 38.872333-22.245653 63.305815-22.245653 24.421202 0 45.527916 7.55814 62.768579 22.245653 17.496489 14.681374 26.258037 32.209586 26.258037 52.547797C670.118204 287.644209 661.356656 305.141722 643.860167 319.355445z" fill="#5046e3" p-id="2907"></path></svg>
                    </div>
                    <div>附件</div>
                </div>
                <div class="topic-file-container">
                    <div class="topic-file-item-title">
                        其他附件
                    </div>
                    <div>
                        <el-upload class="upload-demo"
                                   v-model:file-list="fbfjFileList"
                                   :action="serviceUrl+'/businessservice/topicFile/uploadFile'"
                                   :headers="{ token }"
                                   :on-remove="handleFileRemove"
                                   :data="{ topicStatus: 5, topicFileType: 9}"
                                   accept=".pdf,.jpg,.png,"
                                   :before-upload="beforeFileUpload">
                            <div style="display: flex">
                                <div class="upload-btn-container">
                                    <svg t="1746518248739" style="margin-top: 8px;margin-left: 35px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3360" data-spm-anchor-id="a313x.search_index.0.i4.d8173a810FCVuU" width="20" height="20"><path d="M682.7 85.3L896 298.6v597.7a42.4 42.4 0 0 1-42.4 42.3H170.4a42.7 42.7 0 0 1-42.4-42.3V127.7c0-23.4 19-42.4 42.4-42.4h512.3zM554.7 512h128L512 341.3 341.3 512h128v170.7h85.3V512z" p-id="3361" fill="#ffffff"></path></svg>
                                    <div>&nbsp;&nbsp;&nbsp;选择文件</div>
                                </div>
                                <div class="upload-btn-tip">
                                    支持格式：pdf&nbsp;jpg&nbsp;png &nbsp;&nbsp; 大小限制：5M
                                </div>
                            </div>

                        </el-upload>
                    </div>
                </div>

                <div class="apply-btn-container">
                    <div  class="apply-btn" @click="handleRelease">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import { leadInfo,releaseTopic,releaseTopicFile} from "@/api/admin/lead"
import {timestampToTime} from "@/utils/date";
export default {
    name: "topicRelease",
    components: {},
    props:{
        infoId:{
            type: String,
            default:null,
        },
    },
    data() {
        return {
            listMode:'list',
            token: this.$storage.get("token"),
            serviceUrl,
            timestampToTime,
            topicId:'',
            info:{},
            releaseInfo:{},
            sbsFileList:[],//立项申报书
            tzsFileList:[],//立项通知书
            ktbgFileList:[],//开题报告
            jtbgFileList:[],//结题报告
            gzbgFileList:[],//工作报告
            lwzzFileList:[],//论文与著作
            alkjFileList:[],//教学案例与课件
            hjzsFileList:[],//获奖证书
            fbfjFileList:[],//发布附件
            releaseForm:{
                topicId:'',
                fileUrls:'',
            },
        };
    },
    created() {},
    mounted() {
        this.topicId =  this.infoId;
        this.getTopicInfo();
        this.getTopicReleaseFile();
    },
    unmounted() {},
    computed: {},
    methods: {
        getTopicInfo() {
            leadInfo({ topicId: this.topicId }).then(res => {
                if (res.data.code === 1) {
                    this.info = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        getTopicReleaseFile(){
            releaseTopicFile({ topicId: this.topicId }).then(res => {
                if (res.data.code === 1) {
                    this.releaseInfo = res.data.data;
                    //立项申报书
                    this.releaseInfo.sbsFileList.forEach(e => {
                        this.sbsFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                    //立项通知书
                    this.releaseInfo.tzsFileList.forEach(e => {
                        this.tzsFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                    //开题报告
                    this.releaseInfo.ktbgFileList.forEach(e => {
                        this.ktbgFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                    //结题报告
                    this.releaseInfo.jtbgFileList.forEach(e => {
                        this.jtbgFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                    //工作报告
                    this.releaseInfo.gzbgFileList.forEach(e => {
                        this.gzbgFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                    //论文与著作
                    this.releaseInfo.lwzzFileList.forEach(e => {
                        this.lwzzFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                    //教学案例与课件
                    this.releaseInfo.alkjFileList.forEach(e => {
                        this.alkjFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                    //获奖证书
                    this.releaseInfo.hjzsFileList.forEach(e => {
                        this.hjzsFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                    //立项申报书
                    this.releaseInfo.fbfjFileList.forEach(e => {
                        this.fbfjFileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                code:1,
                                data: e.fileUrl
                            }
                        })
                    })
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        /*移除文件*/
        handleFileRemove(file, uploadFiles) {
            // if (file.response.data) {
            //     deleteTopicFile({ fileUrl: file.response.data }).then(res => {})
            // }
        },
        /*学历文件上传*/
        beforeFileUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'image/png' ||
              rawFile.type === 'image/jpg'||
              rawFile.type === 'image/jpeg')) {
                this.$message.error('暂不支持此类型文件')
                return false
            } else if (rawFile.size / 1024 / 1024 > 5) {
                this.$message.error('文件大小不得超过5M')
                return false
            }
            return true
        },
        handleRelease(){
            const fileList = [];
            if (this.tzsFileList.length === 0) {
                this.$message.error("请上传立项通知书")
                return;
            }
            if (this.ktbgFileList.length === 0) {
                this.$message.error("请上传开题报告")
                return;
            }
            if (this.jtbgFileList.length === 0) {
                this.$message.error("请上传结题报告")
                return;
            }
            if (this.alkjFileList.length === 0) {
                this.$message.error("请上传教学案例与课件")
                return;
            }

            this.sbsFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.tzsFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.ktbgFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.jtbgFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.gzbgFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.lwzzFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.alkjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.hjzsFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })
            this.fbfjFileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })

            this.releaseForm.topicId = this.topicId;
            this.releaseForm.fileUrls = fileList.toString();
            releaseTopic(this.releaseForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("课题已发布");
                    this.backTopicManager()
                }else {
                    this.$message.error("操作失败")
                }
            })
        },

        backTopicManager(){
            this.$emit('change-active-mode', this.listMode,"2");
        }
    }
};
</script>
<style scoped>
.parent-container{
    height: 100%;
    width: 100%;
}
.content-container{
    height: 100%;
    width: 100%;
    background-color: #fff;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-sign-title-top{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #0d55a4;
    margin-top: 5px;
    text-align: center;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    font-size: 15px;
    color: #333333;
    text-align: center;
}

.topic-sign-form{
    width: 100%;
    height: auto;
}
.item-title-tio{
    font-size: 14px;
    color: #767676;
    font-weight: normal!important;
    margin-left: 60px;
}
/deep/ .el-form-item{
    //margin-bottom: 10px!important;
}
/deep/ .el-form-item__label{
    color:#333333!important;
    font-weight:bold;
    font-size:13px
}

.topic-file-container{
    width: 98%;
    height: auto;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 10px 10px 10px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
    margin-top: 5px;
}
.topic-file-item-title{
    height: 30px;
    color:#333333;
    font-weight:bold;
    font-size:14px
}
.upload-btn-container{
    width: 160px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    display: flex;
}
.upload-btn-tip{
    text-indent: 40px;
    line-height: 40px;
    font-size: 13px;
    font-weight: bold;
    color: #767676;
}
.apply-btn-container{
    width: 100%;
    height: 40px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.apply-btn{
    width: 160px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #0d55a4;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.topic-sign-title{
    display: flex;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 5px;
    margin-top: 5px;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    //line-height: 30px;
    font-size: 15px;
    color: #767676;
}
</style>